import React, { useState, useEffect, useRef } from 'react';

export default function HeroStatement() {
  const isSmallScreen = window.innerWidth <= 768;
  const [isHovered, setIsHovered] = useState(false);

  const [nameClass, setNameClass] = useState('hidden');
  const [imageClass, setImageClass] = useState('hidden');

  useEffect(() => {
      // Trigger the animations when the component mounts
      setTimeout(() => {
          setNameClass('slide-in-left');
          setImageClass('slide-in-right');
      }, 100); // Small delay to start the animation
  }, []);

  if (isSmallScreen) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        fontWeight: '600', width: '80vw'}}>
            <div className={nameClass} style={{ textAlign: 'center', fontSize: '22px', color: '#333333', maxWidth: '80vw' }}>
                Hi, I'm Gavin, a software engineer specializing in high-performance, secure, and scalable systems, with a strong foundation in algorithms and system design.
            </div>
        </div>
    );
  }

  return (

    
    <div style={{ display: 'flex', flexDirection: 'column', 
        gap: isSmallScreen ? '5px' : '15px', fontWeight: '600',
             marginLeft: isSmallScreen ? '0px' : '0px',  }} >
        
        
        <div className={nameClass} style={{ textAlign: 'center', fontSize: isSmallScreen ? '22px' : 'min(3vw, 60px)', color: '#333333' }}>
                Hi, I'm Gavin, a software
            </div>
            <div className={nameClass} style={{ fontSize: isSmallScreen ? '22px' : 'min(3vw, 60px)', textAlign: 'center' }}>
                engineer specializing in high-
            </div>
            <div className={nameClass} style={{ fontSize: isSmallScreen ? '22px' : 'min(3vw, 60px)', textAlign: 'center' }}>
                performance, secure, and scalable
            </div>
            <div className={nameClass} style={{ fontSize: isSmallScreen ? '22px' : 'min(3vw, 60px)', textAlign: 'center' }}>
                systems, with a strong foundation in 
            </div>
            <div className={nameClass} style={{ fontSize: isSmallScreen ? '22px' : 'min(3vw, 60px)', textAlign: 'center' }}>
            algorithims and system design.
            </div>

            </div>
  );
}